import { Button, Typography } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { Maybe, StoreUserInfoQuery } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { StoreUserInfoForm } from './StoreUserInfoForm'

export * from './fragments'

export type State = {
  user: Maybe<StoreUserInfoQuery['user']>
  openSMSVerificationModal: boolean
  sendingVerificationLoading: boolean
}

export type Action = {
  onSubmit: (value: {
    phoneNumber: string
    fullName: string
  }) => Promise<void | string>
  onCloseSMSVerificationModal: () => void
  onSendVerificationSMS: () => Promise<void>
}

export const StoreUserInfoTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onCloseSMSVerificationModal,
  onSendVerificationSMS,
}) => {
  const { t } = useTranslation('storeUserInfo')
  const { routerNames } = useRouter()

  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
      }}
    >
      <Head title={routerNames.StoreUserInfo} />
      <Typography variant="subtitle1" sx={{ my: 4 }}>
        {t('label')}
      </Typography>
      <StoreUserInfoForm
        onSubmitSetting={onSubmit}
        deliveryInfo={state.user || {}}
      />

      <InformationModal
        open={state.openSMSVerificationModal}
        onClose={onCloseSMSVerificationModal}
        title={t('verifyTitle')}
        content={
          <Typography variant="body2">
            {t('verifyDesc', {
              phoneNumber: state.user?.formattedPhoneNumber,
            })}
          </Typography>
        }
        buttons={
          <Button
            sx={{ minWidth: 212, mt: 4 }}
            size="large"
            onClick={onSendVerificationSMS}
            loading={state.sendingVerificationLoading}
          >
            {t('verify')}
          </Button>
        }
        cancelText={t('close')}
      />
    </BaseLayout>
  )
}
